import { __rest } from "tslib";
import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Star } from "lucide-react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { StarsRating } from "@skve/components"
 *
 * function Demo() {
 *   return <StarsRating defaultValue={3} />
 * }
 * ```
 */
const StarsRating = React.forwardRef((_a, ref) => {
    var { className, defaultValue, value, onValueChange } = _a, props = __rest(_a, ["className", "defaultValue", "value", "onValueChange"]);
    const [internalValue, setInternalValue] = React.useState(defaultValue);
    const selectedValue = value !== null && value !== void 0 ? value : internalValue;
    const handleValueChange = (nextValue) => {
        const numericValue = Number(nextValue);
        setInternalValue(numericValue);
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(numericValue);
    };
    return (React.createElement(RadioGroupPrimitive.Root, Object.assign({ ref: ref, className: cn("flex w-fit items-center gap-1", className), value: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.toString(), onValueChange: handleValueChange, "aria-label": "Rating" }, props), [1, 2, 3, 4, 5].map((rating) => (React.createElement(RadioGroupPrimitive.Item, { key: rating, value: rating.toString(), "aria-label": `${rating} ${rating === 1 ? "star" : "stars"}`, className: "rounded-sm text-muted-foreground ring-offset-background transition-colors hover:text-yellow-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" },
        React.createElement(Star, { className: cn("h-6 w-6", selectedValue !== undefined && rating <= selectedValue
                ? "fill-yellow-400 text-yellow-500"
                : "fill-transparent") }))))));
});
StarsRating.displayName = "StarsRating";
export { StarsRating };
//# sourceMappingURL=stars-rating.js.map